export default __webpack_public_path__ + "static/media/photography.cdf3d721.svg";